export default {
  cancellationReviewsLoading: (state) => state.cancellationReviewsLoading,
  cancellationReview: (state) => (index) => state.cancellationReviews[index],
  cancellationReviews: (state) => state.cancellationReviews,
  totalCancellationReviews: (state) => state.totalCancellationReviews,
};
